import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import Button from '../../../../UI/Button/Button';
import {hideOverlay} from '../../../actions/overlay-actions';
import Translation from '../../../lang/Translation';
import {getSettings} from '../../../selectors/selectors';
import CV2Helper from '../../helpers/CV2Helper';
import CheckoutOverlay from '../CheckoutOverlay';

export function CV2Overlay(props) {
  return (
    <CheckoutOverlay
      popup
      title="checkout.payment.method.field.cv2.overlay.text.header"
    >
      <div data-test="CV2Overlay">
        <CV2Helper />
    
        {props.shouldUseCv2ModalOnAllDevices && (
          <div className="exitButtonWrap">
            <Button
              primary
              fullWidth
              id="CV2Overlay__closeButton"
              onClick={props.hideOverlay}
            >
              <Translation>checkout.close.button</Translation>
            </Button>
          </div>
        )}
      </div>
    </CheckoutOverlay>
  );
}

CV2Overlay.propTypes = {
  hideOverlay: PropTypes.func.isRequired,
  shouldUseCv2ModalOnAllDevices: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  shouldUseCv2ModalOnAllDevices: !!getSettings(state)?.should_use_cv2_modal_on_all_devices,
});

export default connect(
  mapStateToProps,
  {hideOverlay},
)(CV2Overlay);
